import NativeTiger from "@shared/utils/mobile/nativeTiger";
import { createContext, useEffect, useMemo, useState } from "react";

// Instalar handlers inmediatamente al cargar el módulo
// para que window.TigerUpdateOnlineStatus esté disponible
// antes del primer render de React
NativeTiger.installWindowHandlers();

export const TigerContext = createContext(null);

export default function TigerProvider({ children }) {
    const [isOnline, setIsOnline] = useState(true);

    useEffect(() => {
        NativeTiger.installWindowHandlers(); // idempotente — no hace nada si ya instalado

        const unsub = NativeTiger.on("online", (status) => setIsOnline(!!status));
        return () => unsub();
    }, []);

    const tiger = useMemo(() => {
        return {
            handle: NativeTiger.send,

            // Ejemplo de uso
            scanner: {
                exec: () => NativeTiger.send("tigerStarScanner"),
                on: (cb) => NativeTiger.on("scan", cb),
                // once: () => NativeTiger.once("scan"),
                //  // Esto todavia no lo desarrolle, la idea es poder ejecutar en una linea de forma asincrona
            },

            location: {
                exec: () => NativeTiger.send("tigerStartLocation"),
                on: (cb) => NativeTiger.on("location", cb),
            },

            camera: {
                exec: () => NativeTiger.send("tigerStartCamera"),
                on: (cb) => NativeTiger.on("camera:photo", cb),
            },

            files: {
                pick: ({ mimeType }) => {
                    NativeTiger.send("tigerOpenFile", { mimeType });
                    return NativeTiger.once("file");
                },
                on: (cb) => NativeTiger.on("file", cb),
            },

            biometrics: {
                checkAvailable: () => {
                    NativeTiger.send("tigerIsAvailableBiometrics");
                    return NativeTiger.once("biometric:available");
                },
                auth: () => {
                    NativeTiger.send("tigerStartAuthenticationBiometrics");
                    return NativeTiger.once("biometric:result");
                },
                onResult: (cb) => NativeTiger.on("biometric:result", cb),
            },

            tokenPN: {
                exec: () => NativeTiger.send("tigerTokenNewPushNotification"),
                on: (cb) => NativeTiger.on("token", cb),
            },

            ui: {
                statusBar: (color) => NativeTiger.send("tigerColorStatusBar", { color }),
                footerBar: (color) => NativeTiger.send("tigerBottomBarColor", { color }),
            },

            isOnline: {
                value: isOnline,
            },
        };
    }, [isOnline]);

    return <TigerContext.Provider value={tiger}>{children}</TigerContext.Provider>;
}
